module.exports = __webpack_public_path__ + "static/Dan_Leslie_program_Russian-f975f652440d7bd728ef5e38afca5595.pdf";